let appConfig = null;
let configPromise = null;

export const loadConfig = async () => {
    // Return cached config if available
    if (appConfig) return appConfig;
    
    // Prevent multiple simultaneous loads
    if (!configPromise) {
        configPromise = (async () => {
            try {
                const hostname = window.location.hostname;
                let environmentKey = 'staging'; // default
                
                if (hostname.includes('pay-sandbox-us')) environmentKey = 'sandbox-us';
                if (hostname.includes('pay-sandbox-sg')) environmentKey = 'sandbox-sg';
                if (hostname.includes('pay-sandbox-in')) environmentKey = 'sandbox-in';
                if (hostname.includes('pay-us')) environmentKey = 'prod-us';
                if (hostname.includes('pay-sg')) environmentKey = 'prod-sg';
                if (hostname.includes('pay-in')) environmentKey = 'prod-in';
                
                const response = await fetch('/config.json');
                if (!response.ok) throw new Error('Failed to load config');
                
                const allConfigs = await response.json();
                appConfig = allConfigs[environmentKey];
                
                if (!appConfig) throw new Error(`No config found for ${environmentKey}`);
                
                return appConfig;
            } catch (error) {
                console.error('Configuration loading failed:', error);
                throw error;
            } finally {
                configPromise = null;
            }
        })();
    }
    
    return configPromise;
};